<template>
  <main class="page-operative page-operative-data-analysis page-operative-data-analysis-stati-patrimoniali d-flex flex-column h-100">
    <div class="flex-grow-1 container-fluid d-flex flex-column h-100">
      <div class="d-flex align-items-center justify-content-between flex-wrap flex-md-nowrap mb-5">
        <PageTitle class="mb-2 mb-md-0">Stati Patrimoniali a consuntivo</PageTitle>
        <app-router-link v-if="userCanEdit" class="btn btn-primary" :to="{ name: 'operative-company.data-analysis.stati-patrimoniali.add' }">
          Aggiungi Stato Patrimoniale
        </app-router-link>
      </div>

      <StatiPatrimonialiListTable class="report-texts-size" :crediti="results" :edit-enabled="userIsAdmin || userIsContextCompanyConsultant || userIsContextCompanyOwner" @delete="removeConsuntivoStatoPatrimoniale" />
    </div>
  </main>
</template>

<script>

import operativePageMixin from '../../../../../mixins/operativePage';
import loadingDataMixin from '../../../../../mixins/loadingData';
import confirmWithModalMixin from '../../../../../libs/Confirm/mixins/confirmWithModal';

export default {
  mixins: [operativePageMixin, loadingDataMixin, confirmWithModalMixin],
  components: {
    PageTitle: () => import('../../../../components/Layout/LayoutOperative/PageTitle'),
    StatiPatrimonialiListTable: () => import('../../../../components/Operative/ListTable/StatiPatrimonialiListTable'),
    AppRouterLink: () => import('../../../../components/Layout/AppRouterLink'),
  },
  data () {
    return {
      results: null,
    };
  },
  methods: {
    retrieveListData () {
      if (!this.company) {
        return;
      }

      this.resetErrorOnLoadingData();
      this.setDataLoading();
      this.$api.getStatiPatrimoniali(this.company?.id)
        .then(res => {
          this.results = res?.data?.statiPatrimoniali || [];
        })
        .catch(this.setErrorOnLoadingData)
        .finally(this.setDataLoaded)
      ;
    },
    removeConsuntivoStatoPatrimoniale (id) {
      this.confirm('Cancellare lo stato patrimoniale a consuntivo selezionato? L\'operazione è irreversibile', 'Ok', 'Annulla')
        .then(confirmed => {
          if (!confirmed) {
            return;
          }

          this.$api.deleteStatoPatrimoniale(this.company.id, id).then(() => this.retrieveListData()).catch(this.$log.error);
        })
      ;
    },
  },
  watch: {
    company: {
      immediate: true,
      handler: function () {
        this.retrieveListData();
      },
    },
  },
};

</script>
